import type { IAddressService } from '@/services/interfaces/IAddressService'
import type { IModalityService } from '@/services/interfaces/IModalityService'
import { MockAddressService } from '@/services/implementations/MockAddressService'
import { MockModalityService } from '@/services/implementations/MockModalityService'
import { GoogleAddressService } from '@/services/implementations/GoogleAddressService'
import { env } from '@/lib/env'

export class ServiceFactory {
  static createAddressService(): IAddressService {
    // Use Google service if API key is available, otherwise use mock
    if (env.GOOGLE_MAPS_API_KEY && env.GOOGLE_MAPS_API_KEY !== 'your_google_maps_api_key_here') {
      try {
        return new GoogleAddressService()
      } catch (error) {
        console.warn('Failed to initialize Google Address Service, falling back to mock:', error)
        return new MockAddressService()
      }
    }
    
    return new MockAddressService()
  }

  static createModalityService(): IModalityService {
    // For now, always use mock service
    // Later we can add: if (env.USE_REAL_API) return new ApiModalityService()
    return new MockModalityService()
  }
}